import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import Navigation from '../components/Navigation';
import OrganisationTable from '../components/OrganisationTable';
import axios from 'axios';
import {
    Panel,
    Col,
    Row,
    Button,
    FormControl,
    Form,
    FormGroup,
    InputGroup
} from 'react-bootstrap';
import PaginationPanel from '../components/PaginationPanel';
import config from '../config';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import './Organisations.css';

class Organisations extends Component {
    constructor(props) {
        super(props);

        this.state = {
            organisations: [],
            page: props.page,
            pageCount: 0,
            limit: 40,
            search: props.search,
            selected: props.selected - 1
        };
    }

    componentDidMount() {
        this.loadOrganisationsFromServer();
    }

    deactivateOrganisation(organisation) {

        var self = this;
        axios
            .delete(
                `${config.baseURL}/organisations/${organisation.uuid}`
            )
            .then(function(response) {
                self.loadOrganisationsFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    deleteOrganisation(organisation, password, token) {
        
        const { t } = this.props;

        var self = this;
        axios
            .post(`${config.baseURL}/organisations/${organisation.uuid}/deletepermanent`, {
                password,
                authToken: token
            })
            .then(function(response) {
                self.loadOrganisationsFromServer();
            })
            .catch(function(error) {
                self.setState({
					error: {
						hidden: false,
						title: `${t('OrganisationUsers.error')}:`,
						style: 'danger',
						message: "Unable to delete Organisation. Please check the password and token provided."
					}
				});
        });
    }

    loadOrganisationsFromServer() {
        var self = this;

        axios
            .get(`${config.baseURL}/organisations`, {
                params: {
                    page: self.state.page,
                    limit: self.state.limit,
                    search: self.state.search
                }
            })
            .then(function(response) {
                self.setState({
                    organisations: response.data.organisations,
                    pageCount: response.data.pageCount
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handlePageClick = data => {
        let selected = data.selected + 1;

        const url = new URL(window.location.href);
        url.searchParams.set('page', selected);
        window.history.pushState(null, null, url); 

        this.setState({ page: selected, selected: data.selected }, () => {
            this.loadOrganisationsFromServer();
        });
    };

    handleSubmit = event => {
        const { t } = this.props;

        const url = new URL(window.location.href);

        if(this.state.search) {
            url.searchParams.set('search', this.state.search);
        } else {
            url.searchParams.delete('search');

        }
        window.history.pushState(null, null, url);

        event.preventDefault();
        this.loadOrganisationsFromServer();
    };

    render() {
        const { t } = this.props;
        document.title = `MySign Digital Screen Solutions | ${t(
            'Organisations.title'
        )}`;

        const childProps = {
            currentOrganisation: this.props.currentOrganisation,
            changeOrganisation: this.props.changeOrganisation
        };

        return (
            <div className="Organisations">
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <div className="page-header">
                                <h1>
                                    {t('Organisations.title')}
                                </h1>
                                <div className="header-pagination">
                                <ReactPaginate
                                            previousLabel={t(
                                                'Pagination.previous'
                                            )}
                                            nextLabel={t('Pagination.next')}
                                            breakLabel={<Link to="#">...</Link>}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'pagination'}
                                            subContainerClassName={
                                                'pages pagination'
                                            }
                                            activeClassName={'active'}
                                            forcePage={this.state.selected}
                                        />
                                </div>
                                    <Link
                                        type="submit"
                                        className="btn btn-primary"
                                        to="/organisations/create"
                                    >
                                        <em className="fa fa-plus fa-fw" />{' '}
                                        {t('Organisations.add_organisation')}
                                    </Link>
                                
                                </div>
                                <ol className="breadcrumb">
                                    <li className="active">
                                        <i className="fa fa-briefcase" />{' '}
                                        {t('Organisations.title')}
                                    </li>
                                </ol>


                                <PaginationPanel
                                    heading={
                                        <Row>
                                            <Col xs={12} className="text-right">
                                                <form
                                                    role="search"
                                                    onSubmit={this.handleSubmit}
                                                >
                                                    <FormGroup controlId="search">
                                                        <InputGroup>
                                                            <FormControl
                                                                type="text"
                                                                value={
                                                                    this.state
                                                                        .search
                                                                }
                                                                onChange={
                                                                    this
                                                                        .handleChange
                                                                }
                                                                placeholder={t(
                                                                    'Search'
                                                                )}
                                                            />
                                                            <InputGroup.Button>
                                                                <Button
                                                                    onClick={
                                                                        this
                                                                            .handleSubmit
                                                                    }
                                                                >
                                                                    <i className="glyphicon glyphicon-search" />
                                                                </Button>
                                                            </InputGroup.Button>
                                                        </InputGroup>
                                                    </FormGroup>
                                                </form>
                                            </Col>
                                        </Row>
                                    }
                                    pagination={
                                        <ReactPaginate
                                            previousLabel={t(
                                                'Pagination.previous'
                                            )}
                                            nextLabel={t('Pagination.next')}
                                            breakLabel={<Link to="#">...</Link>}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={3}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'pagination'}
                                            subContainerClassName={
                                                'pages pagination'
                                            }
                                            activeClassName={'active'}
                                            forcePage={this.state.selected}
                                        />
                                    }
                                >

                                    <OrganisationTable
                                        organisations={this.state.organisations}
                                        childProps={childProps}
                                        onDeactivate={this.deactivateOrganisation.bind(this)}
                                        onDeleteOrganisation={this.deleteOrganisation.bind(this)}

                                    />
                                </PaginationPanel>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}
export default translate('translations')(Organisations);
